import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import ClientPortal from "./pages/ClientPortal";

const API = process.env.REACT_APP_API_URL || "http://ec2-3-82-110-23.compute-1.amazonaws.com:8000";

export function useAuth() {
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem("wayne_user");
    return saved ? JSON.parse(saved) : null;
  });

  const login = async (username, password) => {
    const form = new URLSearchParams();
    form.append("username", username);
    form.append("password", password);
    const res  = await fetch(`${API}/auth/login`, { method: "POST", body: form });
    if (!res.ok) throw new Error("Invalid credentials");
    const data = await res.json();
    const user = { ...data, username };
    sessionStorage.setItem("wayne_user", JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    sessionStorage.removeItem("wayne_user");
    setUser(null);
  };

  return { user, login, logout };
}

export const API_BASE = API;

function App() {
  const { user, login, logout } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          user ? <Navigate to={user.role === "admin" ? "/admin" : "/portal"} /> :
          <Login onLogin={login} />
        } />
        <Route path="/admin/*" element={
          user?.role === "admin" ? <AdminDashboard user={user} onLogout={logout} /> :
          <Navigate to="/login" />
        } />
        <Route path="/portal/*" element={
          user && user.role !== "admin" ? <ClientPortal user={user} onLogout={logout} /> :
          <Navigate to="/login" />
        } />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
